import { request } from './client';
import type { LocationFeedback, SubmitFeedbackRequest } from './types';

/**
 * What to ask this guest, if anything.
 *
 * A separate call rather than a field on the session, for two reasons. Campaigns are scheduled, so the answer
 * is time-dependent and the session payload is written to `localStorage` and read back after a gateway
 * round-trip — it would go stale in the one place staleness is hardest to notice. And most guests never reach
 * the feedback prompt, so putting a campaign's questions in every session payload spends bytes on a screen
 * most people close before they see.
 *
 * The location comes from the token; there is nothing for the caller to pass and nothing it could get wrong.
 */
export function getFeedback(token: string, signal?: AbortSignal): Promise<LocationFeedback> {
    return request<LocationFeedback>('/feedback', { token, signal });
}

/**
 * Records what the guest answered.
 *
 * The API pins the transaction from the session's own check and payment, so nothing here says which one — see
 * `SubmitFeedbackRequest`.
 */
export function submitFeedback(
    token: string,
    body: SubmitFeedbackRequest,
    signal?: AbortSignal,
): Promise<{ id: string }> {
    return request<{ id: string }>('/feedback', { method: 'POST', token, body, signal });
}
